import * as React from 'react';
import { Popover, OverlayTrigger, Button } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import { LocalDateTime } from '../../../features/localDate/DateTimeView';
import ReturnedMessageText from '../../../features/orders/view/planOrders/admin/ReturnedMessageText';

interface IProps {
    extraInformation: string;
    returnedMessages: {
        returnedMessage: string;
        returnedDate: LocalDateTime;
    }[];
}

const CustomerMessages = (props: IProps) => {
    const popover = (
        <Popover id="povr" title={Translate('customer-messages/title')} style={{ zIndex: 2000 }}>
            <dl>
                {props.extraInformation && [
                    <dt>{Translate('customer-messages/headers/extra-information')}</dt>,
                    <dd>{props.extraInformation}</dd>
                ]}
                {props.returnedMessages && props.returnedMessages.length > 0 && (
                    <ReturnedMessageText
                        title={<dt>{Translate('customer-messages/headers/return-message')}</dt>}
                        returnedMessages={props.returnedMessages}
                        showSingleMessage={true}
                    />
                )}
            </dl>
        </Popover>
    );

    return (
        <OverlayTrigger trigger="click" placement="bottom" overlay={popover}>
            <Button>{Translate('customer-messages/button')}</Button>
        </OverlayTrigger>
    );
};

export default CustomerMessages;
